import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import Logo from './Logo';
import './Footer.css';

const LANGS = [
  { code: 'en', label: 'EN', title: 'English' },
  { code: 'ru', label: 'RU', title: 'Русский' },
  { code: 'uz', label: 'UZ', title: "O'zbekcha" },
];

export default function Footer() {
  const { t, lang, setLang } = useLang();
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <Logo size={32} tone="dark" />
              <span className="notranslate" translate="no">SkillUp Academy</span>
            </div>
            <p className="footer-tagline notranslate" translate="no">SkillUp &amp; Step Up! 🚀</p>
            <p className="footer-desc">Premium online education platform delivering world-class instruction in languages and mathematics.</p>
          </div>

          <div className="footer-col">
            <h4>{t('nav_courses')}</h4>
            <ul>
              <li><Link to="/courses">General English</Link></li>
              <li><Link to="/courses">IELTS / CEFR</Link></li>
              <li><Link to="/courses">SAT / Westminster</Link></li>
              <li><Link to="/courses">Russian / Uzbek</Link></li>
              <li><Link to="/courses">German / Spanish</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>SkillUp</h4>
            <ul>
              <li><Link to="/teachers">{t('nav_teachers')}</Link></li>
              <li><Link to="/prices">{t('nav_prices')}</Link></li>
              <li><Link to="/feedback">{t('nav_feedback')}</Link></li>
              <li><Link to="/how-it-works">{t('nav_how')}</Link></li>
              <li><Link to="/faq">{t('nav_faq')}</Link></li>
              <li><Link to="/#apply">{t('nav_enroll')}</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              <li><a href="tel:+998880446431">+998 88 044 64 31</a></li>
              <li><a href="mailto:info@skillup.uz">info@skillup.uz</a></li>
              <li><a href="https://t.me/skill_up_academy_admin" target="_blank" rel="noreferrer">@skill_up_academy_admin</a></li>
              <li><a href="https://instagram.com/skillupacademy" target="_blank" rel="noreferrer">Instagram</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} SkillUp Academy. All rights reserved.</p>
          {/* These three read as a switcher, so they are one: as plain text they
              were a dead end for anyone who scrolled down looking for it. */}
          <div className="footer-langs" role="group" aria-label="Language / Язык / Til">
            {LANGS.map(l => (
              <button
                key={l.code}
                type="button"
                lang={l.code}
                title={l.title}
                aria-label={l.title}
                aria-pressed={lang === l.code}
                className={`footer-lang ${lang === l.code ? 'active' : ''}`}
                onClick={() => setLang(l.code)}
              >{l.label}</button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
